import { render, staticRenderFns } from "./AddCompanyForm.vue?vue&type=template&id=3119bb3a&"
import script from "./AddCompanyForm.vue?vue&type=script&lang=js&"
export * from "./AddCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports